/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_MunicipalityInputs */

const cs_enum_municipality = /** @type {(inputs: Enum_MunicipalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obec`)
};

const en_enum_municipality = /** @type {(inputs: Enum_MunicipalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Municipality`)
};

/**
* | output |
* | --- |
* | "Municipality" |
*
* @param {Enum_MunicipalityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_municipality = /** @type {((inputs?: Enum_MunicipalityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_MunicipalityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_municipality(inputs)
	return cs_enum_municipality(inputs)
});